import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type Props = {
  /** モックの説明ラベル */
  label: string;
  children: React.ReactNode;
};

/**
 * ガイド画面内のモック表示用コンテナ。
 * ラベル付きのボーダーで囲んだ領域にモックUI部品を配置する。
 */
const GuideMockContainer: React.FC<Props> = ({ label, children }) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          px: 1.5,
          py: 0.5,
          bgcolor: 'action.hover',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={600}>
          {label}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5 }}>{children}</Box>
    </Box>
  );
};

export default GuideMockContainer;
